/**
 *
 * Jira
 *
 */

import React from 'react';

import { Clients } from '@ariksa/notification';
import { ClientsApiAddClientRequest } from '@ariksa/notification/api';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { actions } from '../../../../slice';

import { JiraForm } from './JiraForm';

export const CreateJira = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onCreate = data => {
    const {
      url,
      user,
      token,
      name,
      project_id,
      default_assignee,
      issue_type,
      board,
    } = data;
    const payload: ClientsApiAddClientRequest = {
      clientConfig: {
        client_name: Clients.Jira,
        status: true,
        name,
        jira: {
          url,
          user,
          token,
          project_name: project_id.label,
          project_id: project_id.value,
          account_id: default_assignee?.value,
          default_assignee_name: default_assignee?.label,
          default_issue_type: issue_type?.value,
          default_board_name: board?.label,
          default_board_id: board?.value,
        },
      },
    };
    dispatch(
      actions.createClient({
        q: payload,
        onSuccess: res => {
          navigate('/setup/integrations/' + Clients.Jira);
        },
      }),
    );
  };

  return <JiraForm handleSubmit={onCreate} />;
};
